/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Link, Typography, FormLabel, Skeleton, Stack, Chip, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { paths } from '@/app/routes';
import { useObjectContext } from '@/hooks/useObjectContext';
import { useListContactsQuery } from '@/features/contacts/contactsApi';
import { getObjectChipProps } from '@/utils/objectChip';

export const AssociatedClient = ({ hideHeader = false }) => {
	const theme = useTheme();
	const { clientRow, isClientLoading, isClientView: isClient } = useObjectContext();

	const { data: mainContact, ...contactQuery } = useListContactsQuery(clientRow?.clientId, {
		skip: !isClient || !clientRow?.clientId,
		selectFromResult: ({ data, ...rest }) => {
			const mainContact = data?.filter((r) => r.isMainContact);
			return {
				...rest,
				data: mainContact,
			};
		},
	});

	const clientName = isClient ? (mainContact?.Addressee ?? mainContact?.Name) : clientRow?.name;

	const loadingContact = !contactQuery.isError && !contactQuery.isSuccess;

	const isProspect = clientRow?.isProspect;
	const chipProps = getObjectChipProps('prospect', { theme, isProspect });

	return (
		<Stack spacing={0.5}>
			{!hideHeader && <FormLabel>Associated Client</FormLabel>}
			{isClient && loadingContact ? (
				<Skeleton width='100%' />
			) : isClientLoading ? (
				<Skeleton width={200} />
			) : !clientName ? (
				<Typography variant='body1'>No client found</Typography>
			) : (
				<Stack
					direction='row'
					spacing={1}
					alignItems='center'
					sx={{
						maxWidth: 700,
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
					}}
				>
					{!isClient && clientRow.clientId ? (
						<Link
							to={`${paths.clients}/${clientRow.clientId}`}
							component={RouterLink}
							sx={{
								textDecorationLine: 'none',
								alignItems: 'center',
								maxWidth: 200,
								whiteSpace: 'wrap',
							}}
						>
							{clientRow.name}
						</Link>
					) : (
						<Typography variant='body1'>{clientName}</Typography>
					)}
					{isProspect && (
						<Chip
							size='small'
							label='PROSPECT'
							variant='outlined'
							color='primary'
							sx={{
								...chipProps,
							}}
						/>
					)}
				</Stack>
			)}
		</Stack>
	);
};
